export const GUIDE_META = {
  title: "Case Manager Device User Assignment",
  subtitle: "Managing Case Manager access and Device User assignments",
  overview:
    "The Case Manager Device User Assignment feature allows Administrators and Managers to control which Device Users are assigned to a Case Manager. Assignments can be added, changed, or removed based on the Client’s Case Manager Access Mode.",
};

export const GUIDE_FIGURES = {
  accessMode: {
    src: "/images/user-guide/access-mode-care-team-roles.png",
    caption: "Client Settings → Manage Care Team Roles — define Device User access level (All / Group).",
    alt: "Manage Care Team Roles with Device User access level set to Group",
  },
  figure1: {
    src: "/images/user-guide/figure-1-user-management.png",
    caption: "",
    alt: "Figure 1. User Management — locate the Case Manager.",
  },
  figure2: {
    src: "/images/user-guide/figure-2-manage-assignment.png",
    caption: "",
    alt: "Figure 2. Manage Device User Assignment — search and assignment panels.",
  },
  figure3: {
    src: "/images/user-guide/figure-3-device-user-reassignment.png",
    caption: "",
    alt: "Figure 3. Device User Reassignment — assign selected Device Users to a Case Manager.",
  },
};

export const ACCESS_MODES = [
  {
    mode: "ALL",
    label: "All",
    visibility:
      "Can view all Device Users belonging to the Client. No assignment is required for visibility.",
  },
  {
    mode: "GROUP",
    label: "Group",
    visibility:
      "Can view only Device Users assigned to the Case Manager. If no Device Users are assigned, the list is empty.",
  },
];

export const MANAGE_PANELS = [
  {
    title: "Users for Assignment",
    description: "Device Users who can be assigned to the Case Manager.",
  },
  {
    title: "Assigned Users",
    description: "Device Users currently assigned to the Case Manager.",
  },
];

export const SEARCH_TIPS = [
  "Search by Name or Device User ID.",
  "Enter the name or ID in the Search field.",
  "Review the current assignment shown for each Device User to determine whether the user is available or assigned to another Case Manager.",
];

export const ASSIGN_STEPS = [
  "Locate the Device User in the Device Users for Assignment panel.",
  "Use the controls between the panels to move the Device User to Assigned Users.",
  "Continue making additional assignment changes as needed.",
  "Select Save Changes to commit all changes.",
];

export const REASSIGN_STEPS = [
  "If a Device User is already assigned to another Case Manager, the current Case Manager is displayed in the assignment list.",
  "Move the Device User to the Assigned Users panel for the new Case Manager.",
  "Review the reassignment confirmation. Select Save Changes to commit all changes.",
];

export const UNASSIGN_STEPS = [
  "Locate the Device User in Assigned Users.",
  "Move the Device User to the Users for Assignment panel.",
  "The Device User becomes unassigned.",
  "Select Save Changes to commit the change.",
  "The Device User remains associated with the Client and can be assigned to another Case Manager later.",
];

export const DEVICE_LIST_STEPS = [
  "Open the Device Users list/panel.",
  "Select the Device Users whose Case Manager assignment you want to change.",
  "Click on the Device User Reassignment button located at the top right of the table.",
  "In the reassignment window, select the appropriate Case Manager. Select Save & Continue.",
];

export const IMPORTANT_NOTES = [
  "Case Manager Access Mode is configured under Client Settings → Manage Care Team Roles.",
  "Existing Device User assignments are retained when the access mode is changed and can be used for historical reference.",
  "Only Device Users belonging to the same client can be reassigned together from the Device Users list.",
];
